import { useState, useEffect } from "react";
import { read, utils, WorkBook, WorkSheet } from "xlsx";

//constants
import { urlXlsx } from '../Constants';

//types
import { DataByDistrict } from '../types/types';

const useExcelData = () => {

    const [data, setData] = useState<DataByDistrict[]>([] as DataByDistrict[]);
    const [loading, setLoading] = useState<boolean>(true);
    
    useEffect(() => {
        readExcel();       
    },[]);

    const readExcel = () => {
        const req: XMLHttpRequest = new XMLHttpRequest();
        req.open("GET", urlXlsx, true);
        req.responseType = "arraybuffer";

        req.onload = () => {
            var arraybuffer = req.response;

            // convert dataFromXlsx to binary string 
            var dataFromXlsx: Uint8Array = new Uint8Array(arraybuffer);
            var arr: string[] = [];

            for (var i = 0; i !== dataFromXlsx.length; ++i)
            {
                arr[i] = String.fromCharCode(dataFromXlsx[i]);
            }  
            
            var bstr: string = arr.join('');

            // Call XLSX 
            var workbook: WorkBook = read(bstr, {type: "binary"});

            // DO SOMETHING WITH workbook HERE 
            var content: string = workbook.SheetNames[0];

            // Get worksheet
            var worksheet: WorkSheet = workbook.Sheets[content];
            setData(utils.sheet_to_json(worksheet, {raw: false, dateNF:'dd-mm-yyyy'}));
            setLoading(false);            
        }
        req.send();
    }   
    
    return { data, loading }; 
}

export { useExcelData };